<template>
<div class="bg-white container text-center mx-4 py-4 border-b-2 border-blue rounded">
  <div class="font-medium text-2xl">Monthly pricing calculator</div>
  <div class="line my-4"></div>
  <p class="mb-4">How many WHOIS requests do you plan on generating each month?</p>
  <div class="w-full px-4">
    <input :value="requests" @input="onInput" class="w-full p-4 border border-grey rounded focus:border-blue hover:border-blue" placeholder="Enter monthly volume" type="text"></input>

    <table class="w-full text-left my-4" border="0">
      <thead>
        <tr class="text-grey-darkest">
          <th class="">API Calls</th>
          <th class="">Price Per Call</th>
          <th class="">Total Price</th>
        </tr>
      </thead>
      <tbody class="border-t border-b border-grey-light">
        <tr class="tier bg-grey-lighter">
          <td>0&nbsp;&nbsp;-&nbsp;&nbsp;1,000</td>
          <td class="cost">Free</td>
          <td class="your-cost"><span>{{ formatCost(tierOneCost, 2) }}</span></td>
        </tr>
        <tr class="tier">
          <td>Next 50,000</td>
          <td class="cost">$0.009</td>
          <td id="table-calc-tier1" class="your-cost">{{ formatCost(tierTwoCost, 3) }}</td>
        </tr>
        <tr class="tier bg-grey-lighter">
          <td>Next 200,000</td>
          <td class="cost">$0.006</td>
          <td id="table-calc-tier2" class="your-cost">{{ formatCost(tierThreeCost, 3) }}</td>
        </tr>
        <tr class="tier">
          <td>Next 500,000</td>
          <td class="cost">$0.004</td>
          <td id="table-calc-tier3" class="your-cost">{{ formatCost(tierFourCost, 3) }}</td>
        </tr>
        <tr class="tier bg-grey-lighter">
          <td>Any Additional</td>
          <td class="cost">$0.002</td>
          <td id="table-calc-tier4" class="your-cost">{{ formatCost(tierFiveCost, 3) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-cost-row">
          <td class="text-2xl">Monthly cost:</td>
          <td colspan="2" class="">
            <div class="bg-grey-light p-4 text-center my-4 rounded border border-grey">{{ formatCost(totalCost) }}</div>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="text-sm">
      Card payments securely processed by <a class="no-underline" target="_blank" href="https://www.stripe.com">Stripe</a>.
    </div>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      requests: null,
      tierOne: { rate: 0.0, min: 0, max: 1000 },
      tierTwo: { rate: 0.009, min: 1000, max: 51000 },
      tierThree: { rate: 0.006, min: 51000, max: 251000 },
      tierFour: { rate: 0.004, min: 251000, max: 751000 },
      tierFive: { rate: 0.002, min: 751000, max: Infinity },
    }
  },
  computed: {
    tierOneCost () {
      return this.tierCost(this.tierOne, this.requests)
    },
    tierTwoCost () {
      return this.tierCost(this.tierTwo, this.requests)
    },
    tierThreeCost () {
      return this.tierCost(this.tierThree, this.requests)
    },
    tierFourCost () {
      return this.tierCost(this.tierFour, this.requests)
    },
    tierFiveCost () {
      return this.tierCost(this.tierFive, this.requests)
    },
    totalCost () {
      return this.tierOneCost
        + this.tierTwoCost
        + this.tierThreeCost
        + this.tierFourCost
        + this.tierFiveCost
    }
  },
  methods: {
    onInput (e) {
      const val = e.target.value
      if (val === '' || val === null || !isNaN(val) || val === null) {
        this.requests = val
      } else {
        e.target.value = this.requests
      }
    },
    tierCost (tier, requests) {
      var requestCount = parseInt(requests)

      if (requestCount && requestCount > tier.min) {
        var chargableRequests = Math.min(tier.max, requestCount) - tier.min
        return (chargableRequests * tier.rate)
      } else {
        return 0.0
      }
    },
    formatCost (cost, decimals) {
      if (cost && cost > 0) {
        return '$' + cost.toFixed(decimals || 2)
      } else {
        return '$0.00'
      }
    }
  }
}
</script>
<style scoped>
.tier td {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/home/pricing-calculator.vue?3ea99f34